import register from '../util/register'
import angular from 'angular'
import UpgradeTeaserController from './UpgradeTeaserController'
import UpgradeTeaser from './UpgradeTeaserProvider'

var upgradeTeaser = angular.module('app.upgradeTeaser',
  [])

register('app.upgradeTeaser')
  .controller('UpgradeTeaserController', UpgradeTeaserController)
  .service('UpgradeTeaser', UpgradeTeaser)

upgradeTeaser.run()